import styled from 'styled-components';

export const TextImage = styled.img`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 220px;
  width: 100%;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 30px;
  }
`;
export const FAQContainer = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 0;
    max-width: 600px;
  }
`;

export const Title = styled.h2`
  font-size: 2em;
  color: #0044cc;
  text-align: center;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 1.5em;
    margin-bottom: 30px;
  }
`;

export const FAQItem = styled.div`
  background-color: #fff;
  margin-bottom: 10px;
  width: 100%;
  border-radius: 18px;

  @media (max-width: 768px) {
    margin-bottom: 5px;
  }
`;

export const QuestionText = styled.p`
  font-size: 1.2em;
  color: #000;
  padding-right: 4em;
  padding-left: 1em;
  cursor: pointer;
`;

export const Question = styled.div`
  padding: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    padding-right: 60px;
  }
  @media (max-width: 768px) {
    padding: 10px;
    font-size: 0.9em;
  }
`;

export const Icon = styled.span`
  font-size: 1.5em;
  transform: ${({ isActive }) => (isActive ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;

  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;

export const Answer = styled.div`
  padding: 2em;
  font-size: 21px;
  color: #666;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    padding: 2em;
    font-size: 16px;
  }
`;

export const BtnMobile = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    width: 90%;
    margin: auto;
  }
`;
